<template>
    <div
        class='dialog-box'
        v-show='show'
    >
        <transition name='isdialog'>
            <div
                class="modal open"
                tabindex="0"
                style="z-index: 1003;opacity: 1; top: 10%; transform: scaleX(1) scaleY(1);"
            >
                <div class="modal-content">
                    <h4>{{title | language}}</h4>
                    <p>{{content}}</p>
                </div>
                <div class="modal-footer">
                    <a
                        @click="confirm"
                        class="modal-close waves-effect waves-red btn-flat"
                    >{{confirmText | language}}</a>
                    <a
                        v-show="showCancel"
                        @click="close"
                        class="modal-close waves-effect waves-green btn-flat"
                    >{{cancelText | language}}</a>
                </div>
            </div>

        </transition>
    </div>
</template>

<script>
export default {
    name: 'simpleDialog',
    data() {
        return {
            show: true,
        };
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
        confirmText: {
            type: String,
            default: '确定',
        },
        cancelText: {
            type: String,
            default: '取消',
        },
        showCancel: {
            type: Boolean,
            default: true,
        },
    },
    watch: {},
    beforeUpdate() {
        $('.modal').show();
    },
    updated() {
        $('.modal').show();
    },
    computed: {},
    mounted() {
        /*  console.log($('#date1').val()) 日期的值 */
        try {
            M.AutoInit();
            $('.modal').show();
        } catch (e) {
            $('.modal').show();
        }
    },
    methods: {
        close() {
            this.$emit('cancel', true);
        },
        confirm() {
            this.$emit('confirm', true);
        },
    },
};
</script>

<style lang="less" scoped>
.dialog-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.isdialog-enter-active,
.isdialog-leave-active {
    transition: all ease 0.5s;
}
.isdialog-enter,
.isdialog-leave-to {
    transform: scale(0);
    opacity: 0;
}
.content {
    background: white;
    transform-origin: 50% 50%;
    display: flex;
    .text {
        text-align: center;
        padding: 2rem 1rem;
        display: inline-block;
    }
}
.bgcolor {
    background: #ba2730;
}
</style>
